<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('medical services')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ patient_uuid: $route.params.patient_uuid }"
      resource_url="/patient/patient-medical-service/datatables"
      :is_container="false"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <medical-service-modal ref="medical_service_modal" @success="refresh" />
    <documents-modal ref="documents_modal" @create_document="create_document" />
    <document-modal ref="document_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import MedicalServiceModal from "./medical_service_modal/Index.vue";
import DocumentsModal from "./documents_modal/Index.vue";
import DocumentModal from "./document_modal/Index.vue";

import {
  get,
  error_message,
  format_date,
  format_currency,
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "MedicalServices",
  components: {
    GenericTable,
    MedicalServiceModal,
    DocumentsModal,
    DocumentModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.date);
          },
        },
        {
          title: v.$t("medical service"),
          // name: "name",
          searchable: false,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.medical_service ? row.medical_service.name : "";
            return `<div class="title is-6">${
              row.medical_service ? row.medical_service.name : ""
            }</div>
            <div class="subtitle is-6">${
              row.doctor_member ? row.doctor_member.name : ""
            }</div>`;
          },
        },
        {
          title: v.$t("description"),
          // name: "name",
          searchable: false,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.description || "";
          },
        },
        {
          title: v.$t("price"),
          searchable: false,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.price);
          },
        },
        // {
        //   title: v.$t("data"),
        //   // name: "name",
        //   searchable: false,
        //   // width: "60%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.medical_service_modal.edit(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("documents"),
                icon: "fa fa-file",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.documents_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete medical service?"),
                    v,
                    () => {
                      del("/patient/patient-medical-service", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    refresh() {
      let v = this;
      // Lógica para obtener las citas del paciente
      // get("/patient/appointment/list", { uuid: v.$route.params.patient_uuid })
      //   .then((appointments) => {
      //     v.appointments = appointments;
      //   })
      //   .catch((error) => {
      //     error_message(error);
      // });

      v.$refs.datatable.refresh();
    },
    create() {
      let v = this;
      v.$refs.medical_service_modal.create();
    },
    create_document(medical_service_uuid) {
      let v = this;
      v.$refs.document_modal.show_modal(medical_service_uuid);
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
